import { render, staticRenderFns } from "./SdTextarea.html?vue&type=template&id=3532ca90&external"
import script from "./SdTextarea.ts?vue&type=script&lang=ts&external"
export * from "./SdTextarea.ts?vue&type=script&lang=ts&external"
import style0 from "./SdTextarea.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports